// extracted by mini-css-extract-plugin
module.exports = {"cardStock":"StockGraph_cardStock__9L-03"};